<template>
    <DataTable
        :header="$t('summary')"
        :fields="fields"
        :items="request.getData() || []"
        :loading="request.getLoading()"
        :error="request.getError()"
        class="mb-4"
    >
        <template #headerSide>
            <div class="d-flex gap-3">
                <Multiselect
                    :fetch-options-function="fetchCampaigns"
                    :placeholder="$t('selectCampaign')"
                    searchable
                    track-by="id"
                    label="name"
                    select-label=""
                    :disabled="request.getLoading()"
                    show-checkboxes
                    show-selected
                    multiple
                    :close-on-select="false"
                    :clear-on-select="false"
                    class="width-200"
                    @inputTrackBy="campaigns = $event"
                    @change="loadData()"
                />
                <FormSelectTree
                    ref="FormTreeSelect"
                    v-model="categories"
                    :disabled="request.getLoading()"
                    :load-options="fetchCategories"
                    :normalizer="normalizer"
                    :placeholder="$t('category')"
                    multiple
                    class="width-200"
                    show-count-value
                    @change="loadData()"
                />
            </div>
        </template>
        <template #cell(impressions)="{item}">
            <div>{{ item.impressions }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.impressions, item.compareImpressions))" /></div>
        </template>
        <template #cell(clicks)="{item}">
            <div>{{ item.clicks }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.clicks, item.compareClicks))" /></div>
        </template>
        <template #cell(cr)="{item}">
            <div>{{ $format.percent(item.quantity / item.clicks * 100) }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.quantity / item.clicks * 100, item.quantity_compare / item.clicks_compare * 100))" /></div>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import { calcPercentDiff } from '@/utils/number';
    import Difference from '@/components/common/Difference.vue';
    import Multiselect from '@/components/common/Multiselect.vue';
    import FormSelectTree from '@/components/common/FormSelectTree.vue';

    export default {
        name: 'CampaignReport',
        components: {
            DataTable,
            Difference,
            Multiselect,
            FormSelectTree,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.$req('space/CampaignReports'),
                requestCampaigns: this.$req('buyboxes/AvailableCampaigns'),
                requestProductsTree: this.$req('space/ProductsTree'),
                campaigns: [],
                categories: [],
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'name', label: this.$t('campaign'), sortable: true },
                    { key: 'impressions', label: this.$t('impressions'), sortable: true },
                    { key: 'clicks', label: this.$t('clicks'), sortable: true },
                    { key: 'cr', label: this.$t('cr'), sortable: true },
                ];
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const requestParams = { ...(this.timeRange || {}) };
                if (this.campaigns?.length) requestParams.campaigns = this.campaigns.join(',');
                if (this.categories?.length) requestParams.categories = this.categories.join(',');
                return { urlParams, requestParams };
            },
        },
        watch: {
            spaceId: {
                handler: 'loadData',
            },
            timeRange: {
                handler: 'loadData',
            },
        },
        methods: {
            calcPercentDiff,
            loadData() {
                this.fetchReports();
            },
            fetchReports() {
                this.request.get(this.apiParams);
            },
            fetchCampaigns() {
                const id = this.$store.getters['plugin/getProducerPlugin'].id;
                return this.requestCampaigns.get({ urlParams: { id, v: 1 } });
            },
            fetchProductsTree(categoryId) {
                return this.requestProductsTree.get({ urlParams: { spaceId: this.spaceId }, requestParams: { category: categoryId } });
            },
            fetchCategories({ parentNode }) {
                return this.fetchProductsTree(parentNode?.entityId);
            },
            normalizer(node) {
                return {
                    id: node.entityId,
                    label: node.text,
                    children: node.children === true ? null : node.children,
                    isDisabled: node.type === 'product',
                };
            },
        },
        created() {
            this.loadData();
        },
    };
</script>



<style lang="scss" scoped></style>
